import { supabase } from '@/lib/supabase';

/**
 * D4 — labels on documents (« objection », « cas client »), across folders.
 * Managers create them; whoever can edit a document sets them on it. RLS
 * decides both (migration 20261022180000_knowledge_tags_d4.sql).
 */

export interface KnowledgeTag { id: string; name: string }

export const listKnowledgeTags = async (): Promise<KnowledgeTag[]> => {
  const { data, error } = await supabase.from('knowledge_tags').select('id, name').order('name');
  if (error) throw new Error('Les étiquettes ne sont pas accessibles pour le moment.');
  return (data ?? []) as KnowledgeTag[];
};

export const createKnowledgeTag = async (name: string): Promise<KnowledgeTag> => {
  const { data, error } = await supabase.from('knowledge_tags').insert({ name: name.trim() }).select('id, name').single();
  if (error) {
    throw new Error(error.code === '23505' ? 'Cette étiquette existe déjà.' : 'Seuls les managers créent les étiquettes.');
  }
  return data as KnowledgeTag;
};

/** Labels of these documents: document id → label ids. */
export const loadDocumentTags = async (documentIds: string[]): Promise<Record<string, string[]>> => {
  if (!documentIds.length) return {};
  const { data, error } = await supabase.from('knowledge_document_tags').select('document_id, tag_id').in('document_id', documentIds);
  if (error) throw new Error('Les étiquettes ne sont pas accessibles pour le moment.');
  const byDocument: Record<string, string[]> = {};
  for (const row of (data ?? []) as Array<{ document_id: string; tag_id: string }>) {
    (byDocument[row.document_id] ??= []).push(row.tag_id);
  }
  return byDocument;
};

export const setDocumentTag = async (documentId: string, tagId: string, on: boolean): Promise<void> => {
  const { error } = on
    ? await supabase.from('knowledge_document_tags').insert({ document_id: documentId, tag_id: tagId })
    : await supabase.from('knowledge_document_tags').delete().eq('document_id', documentId).eq('tag_id', tagId);
  if (error) throw new Error('L’étiquette n’a pas été modifiée. Vérifiez vos droits sur ce document.');
};
